
// List of constant images
// ---- aboutScreen
export const kAboutScreenImages = {
    letterFox: 'images/aboutScreen/letterFoxIllustration.png',
    missionFox: '/images/aboutScreen/AboutMissionFoxIllustration.png',
}

// ---- courses screens
export const kCoursesImages = {
    logoText: 'images/courses/coursesLogoText.png',
}

// ---- Exercisers
export const kExerciserImages = {
    logoText: '/images/SystemExerciserLogoText.png',
}

// ---- flashScreen
export const kFlashImages = {
    logoText: '/images/SystemFlashLogoText.png',
    noGradeSelected: "/images/courses/CoursesBookIllustration.png",
    resultsEmojiBearSuccess: "/images/courses/resultsStepScreen/emojiBearSuccess.png",
    resultsEmojiBearAlmost: "/images/courses/resultsStepScreen/emojiBearAlmost.png",
    resultsEmojiBearAverage: "/images/courses/resultsStepScreen/emojiBearAverage.png",
    resultsEmojiBearSceptic: "/images/courses/resultsStepScreen/emojiBearSceptic.png",
    resultsEmojiBearConfused: "/images/courses/resultsStepScreen/emojiBearConfused.png",
}

// ---- Games
export const kGamesImages = {
    looseImage: "/images/fox/SystemConfusedFox.png",
    recordImage: "/images/fox/SystemStarsFox.png",
    successImage: "/images/fox/SystemHappyFox.png",
}

// ---- gamesScreen
export const kGamesScreenImages = {
    multiplicationBackground: "/images/gamesScreen/multiplicationBackground.png",
    relativeSumBackground: "/images/gamesScreen/relativeSumBackground.png",
}

export const kHomeScreenImages = {
    foxWithPhone: "/images/homeScreen/HomePhoneIllustration.png",
}

// ---- SYSTEM
export const kSystemImages = {
    // Fox
    approvingFox: "/images/fox/SystemApprovingFox.png",
    blinkingFox: "/images/fox/SystemBlinkingFox.png",
    confusedFox: "/images/fox/SystemConfusedFox.png",
    cryingFox: "/images/fox/SystemCryingFox.png",
    happyFox: "/images/fox/SystemHappyFox.png",
    lovingFox: "/images/fox/SystemLovingFox.png",
    scepticalFox: "/images/fox/SystemScepticalFox.png",
    starsFox: "/images/fox/SystemStarsFox.png",
    // Others
    flashLogo: "/images/SystemFlashLogo.png",
    getItOnAppStore: "/images/SystemGetItOnAppStore.png",
    getIsOnPlayStore: "/images/SystemGetItOnPlayStore.png",
    dividerStar: "/images/SystemQuestionDividerStar.png",
    routeNotFound: "/images/System404ErrorImage.png",
    iceBlink: "/images/SystemIceBlink.png",
    iceConfused: "/images/SystemIceConfused.png",
    iceError: "/images/SystemIceError.png",
    iceNormal: "/images/SystemIceNormal.png",
    iceSkeptic: "/images/SystemIceSkeptic.png",
    iceStar: "/images/SystemIceStar.png",
    ummiaLogoText: '/images/SystemUmmiaLogoText.png',
    neoUmmiaLogo: '/images/SystemUmmiaLogo.png',
    neoUmmiaLogoText: '/images/SystemUmmiaNeoLogoText.png',
    neoUmmiaDarkLogoText: '/images/SystemUmmiaNeoDarkLogoText.png',
}